/* ============================================================
   VALSEN — Pont panier Shopify (Couche 2)
   Surcharge le panier factice de valsen.js pour utiliser le VRAI
   panier Shopify via l'API Ajax (/cart/add.js, /cart.js, /cart/change.js).
   Conserve le tiroir anime, le toast et le compteur d'origine.
   Ce script est charge APRES valsen.js.
   ============================================================ */

/* Notification : distingue le succes de l'erreur.
   L'ancienne showToast affichait toujours « Ajouté au panier » avec une coche,
   meme quand l'ajout avait echoue — message contradictoire pour le client. */
function vToast(titre, detail, estErreur){
  var el = document.getElementById('toast');
  if(!el) return;
  var t = el.querySelector('.toast-t');
  var s = el.querySelector('.toast-s');
  var i = el.querySelector('.toast-ico');
  if(t) t.textContent = titre || '';
  if(s) s.textContent = detail || '';
  if(i) i.textContent = estErreur ? '!' : '\u2713';
  el.classList.toggle('toast-error', !!estErreur);
  el.classList.add('show');
  clearTimeout(el._t);
  el._t = setTimeout(function(){ el.classList.remove('show'); }, estErreur ? 4200 : 2600);
}

/* Echappement HTML : protege contre toute injection via les donnees produit
   (titre, variante, URL d'image) rendues dans le tiroir panier. */
function vEsc(v){
  if (v === null || v === undefined) return '';
  return String(v)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
(function(){
  'use strict';

  var money = (window.Shopify && window.Shopify.moneyFormat) || '{{amount}} €';

  /* Formatage monetaire : gere TOUS les gabarits Shopify possibles
     (amount, amount_no_decimals, amount_with_comma_separator,
     amount_no_decimals_with_comma_separator, amount_with_apostrophe_separator).
     Correction : seuls {{amount}} et {{amount_no_decimals}} etaient geres,
     donc une boutique configuree en format francais affichait le gabarit
     brut « {{amount_with_comma_separator}} » dans le panier. */
  function formatMoney(cents){
    var value = cents/100;
    function grouper(entier, sep){
      return entier.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    // 1 234,56 -> decimales avec virgule, milliers avec espace fine
    var virgule = grouper(Math.floor(value).toString(), '\u202F') + ',' + value.toFixed(2).split('.')[1];
    // 1,234.56 -> decimales avec point, milliers avec virgule
    var point = grouper(Math.floor(value).toString(), ',') + '.' + value.toFixed(2).split('.')[1];
    // 1'234.56 -> milliers avec apostrophe
    var apostrophe = grouper(Math.floor(value).toString(), "'") + '.' + value.toFixed(2).split('.')[1];
    var entierSeul = grouper(Math.round(value).toString(), '\u202F');
    return money
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, entierSeul)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, virgule)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, apostrophe)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(value).toString())
      .replace(/\{\{\s*amount\s*\}\}/, point);
  }

  function req(url, opts){
    opts = opts || {};
    opts.headers = Object.assign({'Content-Type':'application/json','Accept':'application/json'}, opts.headers||{});
    return fetch(url, opts).then(function(r){
      return r.json().then(function(data){
        // Shopify renvoie un statut d'erreur (422 si variante indisponible,
        // stock epuise, variante inexistante...). Sans ce controle, l'echec
        // etait traite comme un succes : le panier s'ouvrait mais restait vide.
        if(!r.ok){
          var err = new Error((data && (data.description || data.message)) || 'Ajout impossible');
          err.shopify = data;
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }

  // ─── Etat panier depuis Shopify ───
  function getCart(){ return req('/cart.js'); }

  function updateCount(count){
    var bar = document.getElementById('cart-bar');
    var barCount = document.getElementById('cart-bar-count');
    if(bar) bar.hidden = !(count > 0);
    if(barCount) barCount.textContent = count + (count > 1 ? ' articles' : ' article');
    document.querySelectorAll('.ncta-count').forEach(function(c){
      c.textContent = count;
      c.style.opacity = count > 0 ? '1' : '.55';
    });
  }

  var extraEl = null; // zone "Vider le panier" + suggestions
  // ─── Rendu du tiroir avec les vraies donnees Shopify ───
  // Barre "livraison offerte" (seuil en centimes dans data-seuil du tiroir)
  function renderShip(total){
    var box = document.getElementById('cart-ship');
    if(!box) return;
    if(!total){ box.hidden = true; return; }
    var seuil = parseInt(box.getAttribute('data-seuil') || '10000', 10);
    var t = document.getElementById('cart-ship-t'), f = document.getElementById('cart-ship-fill');
    var reste = seuil - total;
    if(t) t.innerHTML = reste > 0
      ? 'Plus que <strong>' + formatMoney(reste) + '</strong> pour profiter de la livraison offerte'
      : '<strong>Livraison offerte</strong> sur votre commande ✓';
    if(f) f.style.width = Math.min(100, Math.round(total / seuil * 100)) + '%';
    box.hidden = false;
  }

  function renderCartShopify(cart){
    renderShip(cart && cart.items && cart.items.length ? cart.total_price : 0);
    var body = document.getElementById('cart-body');
    var foot = document.getElementById('cart-foot');
    var totalEl = document.getElementById('cart-total');
    if(!body) return;

    if(!cart.items || cart.items.length === 0){
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty-ico">🛍</div><div class="cart-empty-t">Votre panier est vide</div><div class="cart-empty-s">Parcourez la boutique et ajoutez vos coups de cœur.</div><a class="btn-b h" href="/collections/all" style="margin-top:6px"><span>Voir la boutique</span></a></div>';
      if(foot) foot.style.display = 'none';
      extraEl = extraEl || document.getElementById('cart-extra');
      if(extraEl) extraEl.style.display = 'none';
      updateCount(0);
      return;
    }
    if(foot) foot.style.display = '';
    extraEl = extraEl || document.getElementById('cart-extra');

    body.innerHTML = cart.items.map(function(it){
      var img = it.image
        ? '<img src="'+vEsc(it.image)+'" alt="" style="width:100%;height:100%;object-fit:cover">'
        : (it.product_title||'V').charAt(0).toUpperCase();
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? it.variant_title : (it.product_type||'');
      return '<div class="cart-item">'
        + '<div class="cart-item-vig">'+img+'</div>'
        + '<div class="cart-item-info">'
        + '<div class="cart-item-name">'+vEsc(it.product_title)+'</div>'
        + '<div class="cart-item-cat">'+vEsc(variant)+'</div>'
        + '<div class="cart-item-row">'
        + '<div class="cart-qty"><button data-line="'+it.key+'" data-act="dec" aria-label="Diminuer la quantité">−</button><span>'+it.quantity+'</span><button data-line="'+it.key+'" data-act="inc" aria-label="Augmenter la quantité">+</button></div>'
        + '<div class="cart-item-price">'+formatMoney(it.final_line_price)+'</div>'
        + '</div>'
        + '<button class="cart-item-rm" data-line="'+it.key+'" data-act="rm">Retirer</button>'
        + '</div></div>';
    }).join('');

    if(extraEl){ body.appendChild(extraEl); extraEl.style.display = ''; }
    if(totalEl) totalEl.textContent = formatMoney(cart.total_price);
    updateCount(cart.item_count);
    renderUpsell(cart);

    // Boutons quantite / suppression -> /cart/change.js par cle de ligne
    body.querySelectorAll('[data-act]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var key = btn.getAttribute('data-line');
        var act = btn.getAttribute('data-act');
        var line = cart.items.find(function(i){ return i.key === key; });
        if(!line) return;
        var qty = line.quantity;
        if(act === 'inc') qty++;
        else if(act === 'dec') qty = Math.max(0, qty-1);
        else if(act === 'rm') qty = 0;
        // Retour visuel immediat : la ligne se met a jour sans attendre Shopify
        var ligne = btn.closest('.cart-item');
        if(ligne){
          if(qty === 0){ ligne.style.transition='opacity .2s'; ligne.style.opacity='.35'; }
          else { var sp = ligne.querySelector('.cart-qty span'); if(sp) sp.textContent = qty; }
          ligne.querySelectorAll('button').forEach(function(b){ b.disabled = true; });
        }
        req('/cart/change.js', { method:'POST', body: JSON.stringify({ id:key, quantity:qty }) })
          .then(function(newCart){ renderCartShopify(newCart); })
          .catch(function(){ getCart().then(renderCartShopify); });
      });
    });
  }

  // ─── Ouverture du tiroir : recharge depuis Shopify puis affiche ───
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  function showDrawer(){
    if(!drawer) return;
    drawer.classList.add('open');
    if(overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function openCartShopify(){
    if(!drawer) return;
    // Ouverture immediate (le contenu deja affiche reste visible), puis
    // rafraichissement depuis Shopify : plus de latence au clic.
    showDrawer();
    getCart().then(renderCartShopify).catch(function(){});
  }
  window.openCart = openCartShopify;

  // ─── Vider le panier ───
  var clearBtn = document.getElementById('cart-clear');
  if(clearBtn){
    clearBtn.addEventListener('click', function(){
      clearBtn.disabled = true;
      var body = document.getElementById('cart-body');
      if(body){ body.style.transition='opacity .2s'; body.style.opacity='.35'; }
      req('/cart/clear.js', { method:'POST', body:'{}' })
        .then(function(cart){ if(body) body.style.opacity=''; renderCartShopify(cart); })
        .catch(function(){ if(body) body.style.opacity=''; getCart().then(renderCartShopify); })
        .then(function(){ clearBtn.disabled = false; });
    });
  }

  // ─── Completez votre look : recommandations automatiques Shopify ───
  // Basees sur le premier article du panier ; articles deja au panier exclus.
  // Produit a une seule variante : ajout direct. Plusieurs variantes (tailles,
  // couleurs) : lien vers la fiche, pour ne jamais ajouter une taille au hasard.
  var recoCache = {};
  function renderUpsell(cart){
    var box = document.getElementById('cart-upsell');
    if(!box || !cart.items || !cart.items.length) return;
    var pid = cart.items[0].product_id;
    var dejaLa = cart.items.map(function(i){ return i.product_id; });
    function afficher(produits){
      var liste = (produits||[]).filter(function(p){
        return dejaLa.indexOf(p.id) === -1 && p.available;
      }).slice(0,3);
      if(!liste.length){ box.innerHTML=''; box.style.display='none'; return; }
      box.style.display = '';
      box.innerHTML = '<div class="cart-upsell-t">Complétez votre look</div><div class="cart-upsell-list">'
        + liste.map(function(p){
            var img = p.featured_image ? String(p.featured_image) : '';
            if(img){ img += (img.indexOf('?')>-1 ? '&' : '?') + 'width=240'; }
            // Toujours "Choisir" : lien vers la fiche produit
            var action = '<a class="cart-upsell-add h" href="'+vEsc(p.url)+'">Choisir</a>';
            return '<div class="cart-upsell-item">'
              + '<a class="cart-upsell-img" href="'+vEsc(p.url)+'">'+(img?'<img src="'+vEsc(img)+'" alt="" loading="lazy">':'')+'</a>'
              + '<a class="cart-upsell-name" href="'+vEsc(p.url)+'">'+vEsc(p.title)+'</a>'
              + '<div class="cart-upsell-price">'+formatMoney(p.price)+'</div>'
              + action
              + '</div>';
          }).join('') + '</div>';
      box.querySelectorAll('[data-reco-id]').forEach(function(b){
        b.addEventListener('click', function(){
          b.disabled = true;
          addVariant(b.getAttribute('data-reco-id'), 1, b.getAttribute('data-reco-name'));
        });
      });
    }
    if(recoCache[pid]){ afficher(recoCache[pid]); return; }
    fetch('/recommendations/products.json?product_id='+pid+'&limit=6&intent=related')
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .then(function(d){ recoCache[pid] = d.products || []; afficher(recoCache[pid]); })
      .catch(function(){ box.style.display='none'; });
  }

  // Re-brancher le bouton panier de la nav (il pointe vers /cart : on intercepte)
  document.querySelectorAll('.ncta').forEach(function(b){
    // valsen.js a deja pose un ecouteur sur ce bouton (panier de demonstration).
    // On clone l'element pour supprimer TOUS les anciens ecouteurs, sinon les
    // deux paniers s'ouvrent et le contenu fictif peut s'afficher brievement.
    var neuf = b.cloneNode(true);
    if (b.parentNode) { b.parentNode.replaceChild(neuf, b); } else { neuf = b; }
    neuf.addEventListener('click', function(e){ e.preventDefault(); openCartShopify(); });
  });

  // ─── Ajout au panier (boutons .pc-add[data-add] et .pp-add form) ───
  // opts.sansTiroir : n'ouvre pas le tiroir (la page produit l'ouvre elle-meme
  // apres l'animation du bouton). Renvoie true si l'ajout a reussi.
  function addVariant(variantId, qty, name, opts){
    opts = opts || {};
    return req('/cart/add.js', {
      method:'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty||1 }] })
    }).then(function(){
      return getCart();
    }).then(function(cart){
      renderCartShopify(cart);
      vToast('Ajouté au panier', name || 'Article', false);
      if(!opts.sansTiroir) showDrawer();
      return true;
    }).catch(function(err){
      var msg = (err && err.message) ? err.message : 'Cet article ne peut pas être ajouté.';
      if(msg.length > 90) msg = 'Cet article est momentanément indisponible.';
      vToast('Ajout impossible', msg, true);
      console.error('[Valsen] Ajout au panier refusé :', err && err.shopify ? err.shopify : err);
      return false;
    });
  }
  window.valsenAddVariant = addVariant;

  // Cartes produit : bouton "+" -> ajoute la 1re variante disponible
  // Phase de CAPTURE : ce gestionnaire s'execute AVANT ceux poses directement
  // sur les boutons par valsen.js (qui appelle stopPropagation et ajoutait au
  // panier de demonstration). C'est indispensable pour reprendre la main.
  document.addEventListener('click', function(e){
    var quick = e.target.closest('.pc-quick');
    if(quick){
      // Bandeau "Ajouter au panier" au survol : ajoute sans ouvrir la fiche
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var qCard = quick.closest('.pc');
      if(!qCard) return;
      var qVid = qCard.getAttribute('data-variant-id');
      var qName = qCard.getAttribute('data-name') || '';
      // Produit a plusieurs variantes (taille, couleur...) : on ouvre la fiche
      // pour que le client choisisse, au lieu d'ajouter la 1re variante.
      if(parseInt(qCard.getAttribute('data-nv') || '1', 10) > 1){ qVid = null; }
      if(!qVid){
        // pas de variante disponible : on ouvre la fiche produit
        var lien = qCard.getAttribute('href');
        if(lien) window.location.href = lien;
        return;
      }
      addVariant(qVid, 1, qName);
      return;
    }
    var addBtn = e.target.closest('.pc-add[data-add]');
    if(addBtn){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var card = addBtn.closest('.pc');
      if(!card) return;
      var vid = card.getAttribute('data-variant-id');
      var name = card.getAttribute('data-name') || 'Article';
      if(parseInt(card.getAttribute('data-nv') || '1', 10) > 1){
        var lienFiche = card.getAttribute('href');
        if(lienFiche){
          if(e.ctrlKey || e.metaKey){ window.open(lienFiche, '_blank'); }
          else { window.location.href = lienFiche; }
        }
        return;
      }
      if(vid){
        addVariant(vid, 1, name);
        var sp = addBtn.querySelector('span');
        if(sp){ var o=sp.textContent; addBtn.classList.add('added'); sp.textContent='✓'; setTimeout(function(){sp.textContent=o; addBtn.classList.remove('added');},1200); }
      }
    }
  }, true);

  // Formulaire produit (page produit) : soumission Ajax
  var ppForm = document.getElementById('pp-form');
  if(ppForm){
    ppForm.addEventListener('submit', function(e){
      e.preventDefault();
      var idSel = document.getElementById('pp-variant-id');
      var qtyInput = document.getElementById('pp-qty-input');
      var vid = idSel ? idSel.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value||'1',10) : 1;
      var nameEl = document.querySelector('.pp-name');
      var name = nameEl ? nameEl.textContent : 'Article';
      if(!vid) return;
      var btn = document.getElementById('pp-add');
      // Taille pas encore choisie : la fiche produit gere le message
      if(btn && btn.classList.contains('need-size')) return;
      // Sans le nouveau bouton anime : comportement d'origine
      if(!btn || !btn.querySelector('.pp-add-ok')){ addVariant(vid, qty, name); return; }
      if(btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;

      // Animation du bouton : validation immediate (sans barre de chargement),
      // la requete part en parallele ; en cas d'echec le bouton revient et tremble.
      btn.classList.remove('is-error');
      btn.classList.add('is-done');
      var debut = Date.now();
      addVariant(vid, qty, name, {sansTiroir:true}).then(function(ok){
        if(!ok){
          btn.classList.remove('is-done');
          void btn.offsetWidth;
          btn.classList.add('is-error');
          setTimeout(function(){ btn.classList.remove('is-error'); }, 600);
          return;
        }
        // le tiroir s'ouvre des que possible, en laissant 0,6 s pour voir la coche
        setTimeout(showDrawer, Math.max(0, 600 - (Date.now() - debut)));
        setTimeout(function(){ btn.classList.remove('is-done'); }, 1800);
      });
    });
  }

  // Initialisation au chargement : compteur ET contenu du tiroir.
  // valsen.js affiche son panier de demonstration (sessionStorage) des le
  // chargement de chaque page ; sans ce rendu, ce contenu fictif restait en
  // place dans #cart-body jusqu'a la premiere ouverture du panier.
  getCart().then(function(cart){
    updateCount(cart.item_count);
    renderCartShopify(cart);
  }).catch(function(){});

})();
